import useTranslation from '../../../localization/i18n.context';
import ErrorTriangle from '../../../assets/images/info-triangle.webp';
import Popup from '../../shared/Popup/Popup';
import LuckyDeeplink from '../../../constants/lucky.deeplink';
import { CloseWebviewEvent } from '../../../sdk/close.webview.event';
import { DeeplinkEvent } from '../../../sdk/deeplink.event';
import { TrackingEvent } from '../../../sdk/tracking.event';
import NavigationUtils from '../../../utils/navigation.utils';

export const ModalType = {
  ONBOARDING: 'onboarding',
  CREDIT_ONBOARDING: 'credit_onboarding',
};

export default function OnboardingExitModal({
  onCloseClick,
  showing,
  type = ModalType.ONBOARDING,
}) {
  const { t } = useTranslation();

  const handleSecondaryCtaClick = () => {
    switch (type) {
      case ModalType.ONBOARDING:
        TrackingEvent.trigger(
          TrackingEvent.Events.ONBOARDING_LEAVE_TAP,
          TrackingEvent.Sources.CAAS,
        );
        CloseWebviewEvent.closedByUser();
        break;
      case ModalType.CREDIT_ONBOARDING:
        TrackingEvent.trigger(
          TrackingEvent.Events.CREDIT_ONBOARDING_LEAVE_TAP,
          TrackingEvent.Sources.CAAS,
        );

        NavigationUtils.endFlow();
        break;
      default:
        break;
    }
  };

  return (
    <Popup
      title={t('Are you sure you want to exit?')}
      subtitle={t('If you leave, all information will be lost')}
      icon={ErrorTriangle}
      showing={showing}
      primaryCta={{
        text: t('Chat with an agent'),
        onClick: () => {
          // TODO : it is required to change in the future when we implement another client. [CAAS-1449]
          DeeplinkEvent.open(LuckyDeeplink.FAQS);
        },
      }}
      secondaryCta={{
        text: t('Leave onboarding'),
        onClick: () => {
          handleSecondaryCtaClick();
        },
      }}
      onCloseClick={onCloseClick}
      data-testid="leave-pop-up"
    />
  );
}
